let prefixed = name => 'common/' + name

export const brands = prefixed('brands')
export const categories = prefixed('categories')
export const subCategories = prefixed('subCategories')
export const years = prefixed('years')
export const seasons = prefixed('seasons')
export const markets = prefixed('markets')
export const channels = prefixed('channels')
export const countries = prefixed('countries')
export const divisions = prefixed('divisions')
export const departments = prefixed('departments')
export const classes = prefixed('classes')
export const subClasses = prefixed('subClasses')
export const vendors = prefixed('vendors')
export const mills = prefixed('mills')
export const vendorGroups = prefixed('vendorGroups')
export const searchCriteria = prefixed('searchCriteria')

export const isLoaded = prefixed('isLoaded')

export const preInit = prefixed('preInit')
export const initialize = prefixed('initialize')



// WEBPACK FOOTER //
// ./src/components/common/store/definition.js